module.exports = __webpack_public_path__ + "static/img/pc_light.407541e3.png";